import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class Consumption extends BaseModel {
  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.component = rootStore.componentStore.getById(this.componentId);
    this.preparation = rootStore.preparationStore.getById(this.preparationId);
    this.createdByUser = rootStore.userStore.getById(this.createdBy);
    this.updatedByUser = rootStore.userStore.getById(this.updatedBy);
    this.batch = rootStore.batchStore.getById(this.batchId);
  }
}

decorate(Consumption, {
  id: observable,
  batchId: observable,
  batch: observable,
  amount: observable,
  componentId: observable,
  component: observable,
  preparationId: observable,
  preparation: observable,
  targetYieldId: observable,
  originStorageUnitId: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  createdByUser: observable,
  updatedByUser: observable,
});
